<template>
<m-pageframe
    title="{organization-label}: Tags"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px; padding-top: 15px;"
>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>

            <v-list>
                <v-list-item
                    v-on:click="onClickCreateNewTag()"
                >
                    <v-list-item-title>New Tag...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-text-field>

    <v-checkbox
        v-model="show_archived"
        label="Show Archived"
        v-on:change="doUpdate"
        style="margin-top: -15px"
    >

    </v-checkbox>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
        <!-- Admin-only column headers -->
        <template v-if="$rc.$state.isAuthActorSystemAdmin()" v-slot:header.applies_to_media_asset>
            <m-restricted-table-header-cell text="Media Asset" />
        </template>

        <template v-if="$rc.$state.isAuthActorSystemAdmin()" v-slot:header.applies_to_organization>
            <m-restricted-table-header-cell text="Organization" />
        </template>

        <template v-slot:item.label="{ item }">
            <v-chip
                :color="item.color"
            >
            {{item.label}}
            </v-chip>
        </template>

        <template v-slot:item.applies_to_conversations="{ item }">
            <v-simple-checkbox
                :value="item.applies_to.includes('conversation')"
                :ripple="false"
            />
        </template>

         <template v-slot:item.applies_to_bulk_messages="{ item }">
            <v-simple-checkbox
                :value="item.applies_to.includes('bulk-message')"
                :ripple="false"
            />
        </template>

        <template v-slot:item.applies_to_organization="{ item }">
            <v-simple-checkbox
                :value="item.applies_to.includes('organization')"
                :ripple="false"
            />
        </template>

        <template v-slot:item.applies_to_media_asset="{ item }">
            <v-simple-checkbox
                :value="item.applies_to.includes('media-asset')"
                :ripple="false"
            />
        </template>



        <template v-slot:item.is_archived="{ item }">
            <v-simple-checkbox
                :value="item.is_archived"
                :ripple="false"
            />
        </template>

         <template v-slot:item.action="{ item }">
            <v-menu
                bottom
                offset-y
            >

            <template v-slot:activator="{ on }">

                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>

            </template>

            <v-list>
                <v-list-item
                    v-on:click="onClickEdit(item)"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickChangeColor(item)"
                >
                    <v-list-item-title>Change Color...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                 <v-list-item
                    v-on:click="onClickToggleArchive(item)"
                >
                    <v-list-item-title>{{item.is_archived ? 'Un-archive' : 'Archive'}}</v-list-item-title>
                </v-list-item>

            </v-list>

            </v-menu>
        </template>

    </v-data-table>

    <m-tag-color-picker-dialog
        ref="color-picker"
        v-on:update-tag="onUpdateTag"
    />


</v-container>
</m-pageframe>
</template>

<script>

const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            show_archived: false,
            results: []
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        doUpdate()
        {


            this.$rc.rest(
                'LIST: /api/v1/rc-tags',

                {
                    'organization_id' : this.$route.params.organization_id,
                    'full_text': this.full_text,
                    'is_archived': this.show_archived ? null : false,
                },

                (data) => {

                    this.results = data.results;
                },

                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickToggleArchive(tag)
        {
            tag = _.cloneDeep(tag);
            tag.is_archived = !tag.is_archived;

            this.onUpdateTag(tag);
        },

        onUpdateTag(tag)
        {
            this.$rc.rest(
                'PUT: /api/v1/rc-tags',

                tag,

                (data) => {
                    this.doUpdate();
                },

                () => {
                    this.$rc.alert('Error','Unable to archive tag');
                },
            );
        },

        onClickChangeColor(item)
        {
            this.$refs['color-picker'].showDialog(item);
        },

        onClickEdit(item)
        {
            this.$router.push({
                'name': 'settings-organization-tags-edit-one',
                'params' : {
                    'organization_id' : this.$route.params.organization_id,
                    'rc_tag_id': item.rc_tag_id,
                }
            });
        },

        onClickCreateNewTag()
        {
            let tag = {
                'organization_id': this.$route.params.organization_id,
                'rc_tag_id': this.$rc.uuidv4(),
                'label': 'Change me!',
                'notes': 'Type your notes here',
                'color': this.$refs['color-picker'].randomColor(),
                'applies_to': ['conversation','bulk-message'],
                'is_archived': false,
            };

            this.$rc.rest(
                'PUT: /api/v1/rc-tags',

                tag,

                (data) => {
                    this.onClickEdit(tag);
                },

                () => {
                    this.$rc.alert('Error','Unable to create tag');
                },
            );
        },
    },

    computed: {
        headers() {
            let ret = [
                { text: 'Label', value: 'label'},
                { text: 'Notes', value: 'notes'},
                { text: 'Conversations', value: 'applies_to_conversations'},
                { text: 'Bulk Message', value: 'applies_to_bulk_messages'},
            ];

            if ( this.$rc.$state.isAuthActorSystemAdmin() )
            {
                ret.push({ text: 'Media Asset', value: 'applies_to_media_asset'});
                ret.push({ text: 'Organization', value: 'applies_to_organization'});
            }

            ret.push({ text: 'Is Archived', value: 'is_archived'});
            ret.push({ text: 'Action', value: 'action'});

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>